interface IGetUser {
  userId?: number;
  withUxfb?: boolean;
}

export function getAnalyticsUser({ userId, withUxfb }: IGetUser) {
  const extra = withUxfb ? { uxfb_country_projects: 'secondSession' } : undefined;

  return { userId, extra };
}
